define('lq/services/application/issueTracking',[],function () {
    'use strict';

    // todo svb SPA this is a placeholder for the integration with new Runtime validator
    
    function IssueTracking() {
    };

    IssueTracking.typeName = 'IssueTracking';

    IssueTracking.prototype.initialize = function () {
        
    };

    return IssueTracking;
});
